import React, { useState, useEffect, useMemo } from 'react';
import {
	View,
	Platform,
	StyleSheet,
	ScrollView,
	TextInput,
	TouchableOpacity,
	Dimensions,
	useWindowDimensions,
} from 'react-native';
import ImageIcon from '../../Icon/ImageIcon.component';
import I18n from '../../i18n/I18n.component';
import OutlineButtonContainer from '../../Buttons/OutlineButton.container';
import SolidButtonContainer from '../../Buttons/SolidButton.container';
import colors from '../../../../config/colors';
import { Switch } from 'react-native-paper';
import ActionButton from '../../Buttons/ActionButton.container';
interface Option {
	name: string;
	id: string;
	lastReported?: boolean;
}
interface Props {
	onSelect?: Function;
	onSubmit?: Function;
	onCancel?: Function;
	isModal: boolean;
	options: Option[];
	isEventSelect: boolean;
	defaultOption: Option;
	canReportFullDay?: boolean;
	onNext?: Function;
	closed?: Function;
	currentRunnigWorkLog: any
}

const EventsAndProjectsSelectComponent = ({
	isModal,
	onCancel,
	onSubmit,
	options,
	isEventSelect,
	defaultOption,
	onNext,
	closed,
	canReportFullDay,
	currentRunnigWorkLog
}: Props) => {
	useEffect(() => {
		return () => {
			if (isModal) {
				closed?.();
			}
		};
	}, []);
	const { height, width } = Dimensions.get('window');
	const [selectedOption, setSelectedOption] = useState(defaultOption);
	const [searchPattern, setSearchPattern] = useState('');
	const [selectedIndex, setSelectedIndex] = useState<any>(null);
	const [isFullDaySelected, setIsFullDaySelected] = useState(
		canReportFullDay,
	);
	
	const disableEntryButton = selectedOption.id === currentRunnigWorkLog?.eventId ||
						selectedOption.id === currentRunnigWorkLog?.projectId

	const optionsOnView = useMemo(() => {
		const reOrderedOptions = options?.filter(option =>
			option.name.includes(searchPattern),
		);
		reOrderedOptions.map((option: Option, index: number) => {
			if (option.id === defaultOption.id) setSelectedIndex(index);
		});
		return reOrderedOptions;
	}, [searchPattern]);

	const CreateOption = ({
		option,
		index,
	}: {
		option: Option;
		index: number;
	}) => {
		const [isHovered, setIsHovered] = useState(false);  

		return (
			<View
				style={{
					flexDirection: 'row-reverse',
					alignItems: 'center',
					backgroundColor:
						index === selectedIndex ? colors.iconBG : isHovered ? colors.datepickerBG : 'transparent',
					borderBottomWidth: 1,
					borderBottomColor: colors.datepickerSeparator,
				
				}}
			>
				<TouchableOpacity
					style={{
						flex: 1,
						paddingHorizontal: 16,
						paddingVertical: 8,
						height: canReportFullDay && isEventSelect && index === selectedIndex ? 'auto' : 40,
						width: '100%',
						alignItems: 'flex-end',
						flexDirection: 'row-reverse',

					}}
					underlayColor='transparent'
					onMouseEnter={() => setIsHovered(true)}
                	onMouseLeave={() => setIsHovered(false)}
					onPress={() => {
						setSelectedIndex(index);
						setSelectedOption(option);
					}}
				>
					<I18n size={14} weight='400' color='primaryDarkBlue'>
						{option.name}
					</I18n>
				</TouchableOpacity>
				{canReportFullDay && isEventSelect && index === selectedIndex && (
					<View
						style={{
							margin: 10,
							flexDirection: 'row-reverse',
							alignItems: 'center',
						}}
					>
						<I18n
							size={14}
							weight={'normal'}
							style={{ marginHorizontal: 8 }}
							color='clockRecordBlue'
						>
							modal.report.fullDay
						</I18n>
						<Switch
							color={colors.titlePrimary}
							style={{marginRight: 8}}
							onValueChange={() => {
								setIsFullDaySelected(prev => !prev);
							}}
							value={isFullDaySelected}
						/>
					</View>
				)}
			</View>
		);
	};

	return isModal ? (
		<ScrollView
			showsVerticalScrollIndicator
			style={{
				shadowColor: 'rgba(0, 0, 0, 0)',
				shadowOpacity: 0.1,
				shadowOffset: { width: 0, height: 2 },
				backgroundColor: colors.white,
				maxHeight: height - 150,
				borderRadius: 20,
			}}
		>
			<View
				style={{
					width: width - 100,
					height: useWindowDimensions().height - 150,
					paddingVertical: 39,
					paddingHorizontal: 20,
				}}
			>
				<I18n weight='bold' size={24} style={{ marginVertical: 8 }} color='primaryDarkBlue'>
					{isEventSelect ? 'general.events' : 'general.projects'}
				</I18n>
				<View style={styles.Line} />
				<View style={styles.search}>
					<ImageIcon
						name='search'
						style={{
							height: 22,
							width: 22,
							alignSelf: 'center',
							marginLeft: 5,
						}}
					/>
					<TextInput
						style={{
							width: '100%',
							borderColor: 'transparent',
							textAlign: 'right',
							direction: 'rtl',
							...Platform.select({
								web: {
									outlineWidth: 0,
								},
							}),
						}}
						onChangeText={pattern => {
							setSearchPattern(pattern);
						}}
					/>
				</View>
				<ScrollView
					style={{ flex: 1, width: '100%', marginVertical: 10 }}
				>
					{optionsOnView.map((option: Option, index) => (
						<CreateOption
							key={option.id}
							option={option}
							index={index}
						/>
					))}
				</ScrollView>
				<View style={styles.actionButtons}>
					<ActionButton
						onPress={() =>
							onSubmit?.(
								onNext,
								selectedOption,
								isEventSelect,
								isFullDaySelected,
							)
						}
						disabled={disableEntryButton}
						overrideStyle={styles.filledGreenButton}
						hoverStyle={disableEntryButton ? {} : styles.filledGreenButtonHover}
					>
						<I18n size={16} weight='normal' color='white'>
							general.enterence
						</I18n>
					</ActionButton>
					<View style={{ width: 10 }} ></View>
					<ActionButton onPress={() => onCancel?.(onNext)} overrideStyle={styles.outlinedButton}>
						<I18n size={16} weight='normal' color='primary'>
							general.cancel
						</I18n>
					</ActionButton>
				</View>
			</View>
		</ScrollView>
	) : (
		<View
			nativeID='selectWebContainer'
			style={{
				zIndex: 1222,
				position: 'absolute',
				height: 293,
				width: '100%',
				backgroundColor: colors.white,
				...Platform.select({
					web: {
						boxShadow: '0 10px 30px -7px rgba(59, 112, 164, 0.5)',
						backgroundColor: '#fff',
					},
				}),
				borderRadius: 8,
				top: '100%',
				right: 0,
				left: 0,
				paddingVertical: 10,
			}}
		>
			<View style={styles.search}>
				<ImageIcon
					name='search'
					style={{
						height: 15,
						width: 15,
						alignSelf: 'center',
						marginLeft: 5,
					}}
				/>
				<TextInput
					style={{
						width: '100%',
						borderColor: 'transparent',
						textAlign: 'right',
						direction: 'rtl',
						...Platform.select({
							web: {
								outlineWidth: 0,
							},
						}),
					}}
					onChangeText={pattern => {
						setSearchPattern(pattern);
					}}
				/>
			</View>
			<ScrollView style={styles.optionsHolder}>
				{optionsOnView.map((option: Option, index) => (
					<CreateOption
						key={option.id}
						index={index}
						option={option}
					/>
				))}
			</ScrollView>
			<View
				style={{
					flexDirection: 'row',
					alignSelf: 'flex-start',
					paddingHorizontal: 10,
					marginTop: 12,
				}}
			>
				<ActionButton
					onPress={() =>
						onSubmit?.(
							selectedOption,
							isEventSelect,
							isFullDaySelected,
						)
					}
					disabled={disableEntryButton}
					overrideStyle={styles.filledGreenButton}
					hoverStyle={disableEntryButton ? {} : styles.filledGreenButtonHover}
				>
					<I18n size={16} weight='normal' color='white'>
						general.enterence
					</I18n>
				</ActionButton>
				<View style={{ width: 10 }} ></View>
				<ActionButton onPress={() => onCancel?.()} overrideStyle={styles.outlinedButton}>
					<I18n size={16} weight='normal' color='primary'>
						general.cancel
					</I18n>
				</ActionButton>
			</View>
		</View>
	);
};
const styles = StyleSheet.create({
	search: {
		backgroundColor: '#edf4f7',
		width: '95%',
		height: 30,
		alignSelf: 'center',
		borderRadius: 5,
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		paddingHorizontal: 10,
	},
	optionsHolder: {
		flex: 1,
		maxHeight: 180,
		marginVertical: 4,
	},
	actionButtons: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginTop: 10,
	},

	buttonCancel: {
		minWidth: 92,
		height: 40,
		justifyContent: 'center',
		paddingHorizontal: 15,
		padding: 10,
		
	},
	Line: {
		opacity: 0.2,
		width: '100%',
		height: 0,
		borderTopColor: '#525962',
		borderTopWidth: 2,
		marginBottom: 10,
	},
		filledGreenButton: {
			backgroundColor: colors.greenClock,
		},
		filledGreenButtonHover: {
			backgroundColor: colors.greenClockHover,
		},
		filledButton:{
			backgroundColor: colors.primary,
		},
		outlinedButton: {
			borderWidth: 1,
			borderColor: colors.titlePrimary,
		},
});

export default EventsAndProjectsSelectComponent;
